/**
 * Static URLs for assets in `public/images/` (lowercase .jpg, no spaces).
 */
const IMAGES = "/images";

function publicImage(filename: string): string {
  return `${IMAGES}/${encodeURIComponent(filename)}`;
}

/** One entry per file in `public/images/` (canonical path reference). */
export const PublicImages = {
  balloonHoopJpg: publicImage("balloon-hoop-2.jpg"),
  afternoonTea2: publicImage("afternoon-tea-2.jpg"),
  afternoonTeaBox: publicImage("afternoon-tea-box.jpg"),
  afternoonTeaGraze: publicImage("afternoon-tea-graze.jpg"),
  afternoonTeaJpg: publicImage("afternoon-tea.jpg"),
  afternoonteagraze: publicImage("afternoonteagraze.jpg"),
  balloonHoopJpeg: publicImage("balloon-hoop.jpg"),
  grazeTable2: publicImage("graze-table-2.jpg"),
  grazeboxLarge: publicImage("grazebox-large.jpg"),
  grazetablezoom: publicImage("grazetablezoom.jpg"),
  grazezoom: publicImage("grazezoom.jpg"),
  grazingTable: publicImage("grazing-table.jpg"),
  kitchenImage: publicImage("kitchen-image.jpg"),
  mediumBox: publicImage("medium-box.jpg"),
  welcomeDrinks: publicImage("welcome-drinks.jpg"),
} as const;

/** Semantic use across pages (each value is a path under `public/images/`). */
export const SiteImages = {
  homeHero: PublicImages.afternoonTeaJpg,
  homeGrazingBoard: PublicImages.grazingTable,
  homeEventCatering: PublicImages.welcomeDrinks,
  homeGallery1: PublicImages.welcomeDrinks,
  homeGallery2: PublicImages.balloonHoopJpeg,
  homeGallery3: PublicImages.afternoonTea2,
  homeGallery4: PublicImages.grazeTable2,
  aboutHero: PublicImages.afternoonTeaJpg,
  aboutStory1: PublicImages.grazingTable,
  aboutStory2: PublicImages.balloonHoopJpeg,
  menuAfternoonTea: PublicImages.afternoonTeaJpg,
  menuCharcuterie: PublicImages.grazingTable,
  menuGrazingBox: PublicImages.grazeboxLarge,
  menuAfternoonTeaBox: PublicImages.afternoonTeaBox,
} as const;
